<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="退款记录" :icon="null" title="退款管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
                <el-form :model="search" label-width="80px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <!-- <el-col :span="8">
                            <el-form-item label="用户ID:" prop="userId">
                                <el-input v-model="search.userId" placeholder="请输入用户ID" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="userPhone">
                                <el-input v-model="search.userPhone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="退款编号:" prop="refundSerialNumber">
                                <el-input v-model="search.refundSerialNumber" placeholder="请输入退款编号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="支付订单:" prop="orderId">
                                <el-input v-model="search.orderId" placeholder="请输入支付订单号" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        
                        <el-col :span="8">
                            <el-form-item label="退款状态:" prop="refundStatus">
                                <el-select v-model="search.refundStatus" clearable class="m-2" placeholder="请选择退款状态"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="退款时间:" prop="daterange">
                                <el-date-picker v-model="search.daterange" type="datetimerange" range-separator="-"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss" date-format="YYYY-MM-DD" time-format="HH:mm:ss"
                                    style="width: 100%" @change="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 347px)" row-key="id"
                v-loading="state.tableLoading">
                <!-- <el-table-column prop="userId" label="用户ID" min-width="200px" /> -->
                <el-table-column prop="userPhone" label="手机号码" min-width="120px" />
                <el-table-column prop="applicationRefundAmount" label="退款金额" min-width="100px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.applicationRefundAmount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="refundStatus" label="退款状态" min-width="130px">
                    <template #default="scope">
                        <el-text class="mx-1" type="success" v-if="scope.row.refundStatus == '已退款'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="error"
                            v-else-if="scope.row.refundStatus == '拒绝' || scope.row.refundStatus == '已拒绝'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="warning" v-else>
                            {{ scope.row.refundStatus }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="refundType" label="退款类型" min-width="180px" />
                <el-table-column prop="refundReason" label="退款/拒绝原因" min-width="180px" />
                <el-table-column prop="orderNumber" label="支付订单" min-width="200px" />
                <el-table-column prop="refundSerialNumber" label="退款编号" min-width="300px" />
                <el-table-column prop="applicationTime" label="退款时间" min-width="180px" />
                <el-table-column prop="refundTime" label="退款完成的时间" min-width="180px" />
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>

</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { getRefundListFun } from "@/api/refund"
import { formatCurrency } from "@/util/formValidator";

const search = reactive({
    userId: "",
    userPhone: "",
    refundSerialNumber: "",
    orderId: '',
    refundStatus: '',
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "待处理", value: '待处理' },
        { label: "处理中", value: '处理中' },
        { label: "已退款", value: '已退款' },
        { label: "拒绝", value: '拒绝' },
    ],
})
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userId = '';
        search.userPhone = '';
        search.refundSerialNumber = '';
        search.orderId = '';
        search.refundStatus = '';
        search.daterange = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }

    for (let key in search) {
        if (search[key]) {
            if (key == 'daterange') {
                params.formValue['startTime'] = search[key][0];
                params.formValue['endTime'] = search[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else {
                params.keys.push(key);
                params.formValue[key] = search[key];
            }
        }
    }
    getRefundListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}

onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}
</style>